module.exports = __webpack_public_path__ + "static/img/Frame6.c0c93215.png";